/* eslint-disable func-style */
export const distinct = Symbol('distinct');
function distinctImpl<T>(this: Array<T>): Array<T> {
    return [...new Set(this)];
}

export const groupBy = Symbol('groupBy');
function groupByImpl<T, K>(this: Array<T>, keySelector: (item: T) => K): Map<K, T[]> {
    const groups = new Map<K, T[]>();
    for (const item of this) {
        const key = keySelector(item);
        const group = groups.get(key);
        if (group) {
            group.push(item);
        } else {
            groups.set(key, [item]);
        }
    }
    return groups;
}

export const remove = Symbol('remove');
function removeImpl<T>(this: Array<T>, ...items: T[]) {
	for (const item of items) {
        const itemIndex = this.indexOf(item);

        if (itemIndex > -1) {
            this.splice(itemIndex, 1);
        }
    }
}

export const sortBy = Symbol('sortBy');
function sortByImpl<T>(this: T[], propName: string | ((item: T) => string | number)): Array<T> {
    function dynamicSort(property) {
        if (propName && {}.toString.call(propName) === '[object Function]') {
            return function (a, b) {
                let v1 = (<any>propName)(a);
                let v2 = (<any>propName)(b);

                if (v1.constructor && v1.call && v1.apply) {
                    v1 = v1();
                }

                if (v2.constructor && v2.call && v2.apply) {
                    v2 = v2();
                }

                return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
            };
        } else {
            let propArr: string[] = property;
            if (typeof property === 'string' || property instanceof String) {
                propArr = <any>[property];
            }

            return function (a, b) {
                for (let i = 0, len = propArr.length; i < len; i++) {
                    let currProp = propArr[i];
                    let sortOrder = 1;
                    if (currProp[0] === '-') {
                        sortOrder = -1;
                        currProp = currProp.substr(1);
                    }

                    let aVal = a[currProp];
                    let bVal = b[currProp];
                    if (aVal.constructor && aVal.call && aVal.apply) {
                        aVal = aVal();
                    }

                    if (bVal.constructor && bVal.call && bVal.apply) {
                        bVal = bVal();
                    }

                    const result = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
                    if (result != 0) {
                        return result * sortOrder;
                    }
                }

                return 0;
            };
        }
    }

    this.sort(dynamicSort(propName));
    return this;
}


declare global {
    export interface Array<T> {
        [distinct]: typeof distinctImpl;
        [groupBy]: typeof groupByImpl;
        /**
         * Removes given items from the Array
         *
         * @param items Items that should be removed from the Array
         */
        [remove]: typeof removeImpl;
        /**
         * Sorts array by given property
         *
         * @param propName Property name (or function returning the sort key), the array should be sorted by
         */
        [sortBy]: typeof sortByImpl
    }
}

(Array as any).prototype[distinct] = distinctImpl;
(Array as any).prototype[groupBy] = groupByImpl;
(Array as any).prototype[remove] = removeImpl;
(Array as any).prototype[sortBy] = sortByImpl;
